// extracted by mini-css-extract-plugin
module.exports = {"contentLayout":"styles_contentLayout__2qO2R","contentGuestLayout":"styles_contentGuestLayout__1IB_-"};